import anime from "animejs"
import { useRef, useEffect } from "react"

const SocialMedia = () => {


    const element = useRef(null);
    useEffect(() => {
        //const links = document.querySelectorAll()
        window.addEventListener("click", bounce())
        return () => {

        };
    }, []);

    function bounce() {
        anime({
            targets: ".doc1",
            duration: 1000,
            translateY: -100,
            easing: 'easeInOutQuad',
            loop: 5,
            autoplay: false
        })
    }
    return (
        <div className=" flex items-center place-content-center">
            <div>
                <a>
                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z" fill="#0077B5" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M17.3188 14.8227C17.3188 16.3918 16.1377 17.6473 14.2412 17.6473H14.2064C12.3805 17.6473 11.2 16.3918 11.2 14.8227C11.2 13.2204 12.4164 12 14.277 12C16.1377 12 17.2835 13.2204 17.3188 14.8227ZM16.9605 19.8778V36.2196H11.5216V19.8778H16.9605ZM36.5752 36.2196L36.5754 26.8497C36.5754 21.8303 33.8922 19.4941 30.3131 19.4941C27.4254 19.4941 26.1325 21.0802 25.4107 22.1929V19.8783H19.9711C20.0428 21.4117 19.9711 36.22 19.9711 36.22H25.4107V27.0934C25.4107 26.605 25.446 26.1178 25.5898 25.7681C25.9829 24.7924 26.8779 23.7822 28.3805 23.7822C30.3494 23.7822 31.1365 25.2807 31.1365 27.4767V36.2196H36.5752Z" fill="white" />
                    </svg>

                </a>
            </div>
            <div className=" doc2 inline-block w-10 h-10 bg-white text-black" ref={element}>BUTTON2</div>
        </div>

    )
}
export default SocialMedia